import { Card, Flex } from "antd";
import "./styles.css";
import clsx from "clsx";

export const TitleCardsList = ({ options, selectedCard, setSelectedCard }) => {
  return (
    <Flex wrap className="title-cards-list">
      {options.map((option) => {
        const value = option.value ?? option.title;
        return (
          <SmallTitleCard
            key={value}
            title={option.title}
            value={value}
            selectedOptionTitle={selectedCard}
            setSelectedOption={setSelectedCard}
          />
        );
      })}
    </Flex>
  );
};

export const SmallTitleCard = ({
  title,
  value,
  selectedOptionTitle,
  setSelectedOption,
}) => {
  return (
    <Card
      className={clsx(
        "selectable-title-card",
        value === selectedOptionTitle && "selectable-title-card-selected"
      )}
      hoverable
      onClick={() => {
        setSelectedOption(value);
      }}
    >
      <p className="selectable-title-card-title">{title}</p>
    </Card>
  );
};
